/* eslint no-undef: 0, camelcase: 0 */
/* script to create a VWO Experiments super property from the VWO cookie */
window._vis_opt_queue = window._vis_opt_queue || [];

window._vis_opt_queue.push(function () {
  // eslint-disable-next-line prefer-const
  let _vis_combination,
    dataSendingTimer,
    tryPushingDataTimer,
    _vis_data = {};
  if (typeof _vwo_exp_ids !== `undefined`) {
    if (Array.isArray(_vwo_exp_ids)) {
      _vwo_exp_ids.forEach((experimentID) => {
        if (_vwo_exp[experimentID].ready) {
          _vis_combination = _vis_opt_readCookie(`_vis_opt_exp_` + experimentID + `_combi`);
          if (typeof _vwo_exp[experimentID].combination_chosen !== `undefined`) {
            _vis_combination = _vwo_exp[experimentID].combination_chosen;
          }

          if (typeof _vwo_exp[experimentID].comb_n[_vis_combination] !== `undefined`) {
            _vis_data[`VWO-Test-ID-` + experimentID] = _vwo_exp[experimentID].comb_n[_vis_combination];
          }
        }
      });
    }
    clearTimeout(dataSendingTimer);
    (function tryPushingData() {
      clearTimeout(tryPushingDataTimer);
      if (!window.mixpanel || !window.mixpanel.register) {
        tryPushingDataTimer = setTimeout(function () {
          tryPushingData();
        }, 5);
        return;
      }
      dataSendingTimer = setTimeout(function () {
        const experiments = [];
        for (const experiment in _vis_data) {
          experiments.push(experiment + `: ` + _vis_data[experiment]);
        }
        mixpanel.register({'VWO Experiments': experiments});

        _vis_data = {};
      }, 100);
    })();
  }
});
